import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import FileUpload from "../../utils/FileUpload";
import { validateField } from "../../utils/validation/validation";
import { submitBulkCommunity } from "../../services/api";
import { useToast } from "../../contexts/ToastContext";
import { useLoading } from "../../contexts/LoadingContext";

function ImportCommunityModal({ show, onHide }) {
  const [rowErrors, setRowErrors] = useState([]);
  const { showToast } = useToast();
  const { startLoading, stopLoading } = useLoading();

  useEffect(() => {
    if (show) {
      setRowErrors([]);
    }
  }, [show]);

  const validateRow = (row) => {
    const errors = {};
    Object.keys(row).forEach((field) => {
      const error = validateField(field, row[field]);
      if (error) {
        errors[field] = error;
      }
    });
    return Object.keys(errors).length > 0 ? errors : null;
  };

  const handleBulkSubmit = async (parsedData) => {
    const validRows = [];
    const newRowErrors = [];

    parsedData.forEach((row, index) => {
      const errors = validateRow(row);
      if (errors) {
        newRowErrors.push({ row: index + 1, errors });
      } else {
        validRows.push(row);
      }
    });

    setRowErrors(newRowErrors);

    if (newRowErrors.length > 0) {
      showToast("Some rows have validation errors", "error");
      return;
    }

    try {
      startLoading();
      const response = await submitBulkCommunity(validRows);

      const failed = response.results.filter((r) => !r.success);
      const succeeded = response.results.filter((r) => r.success);

      if (succeeded.length > 0 && failed.length > 0) {
        showToast("Some communities were imported, others skipped due to duplicate emails.", "warning");
      } else if (failed.length > 0) {
        showToast("All communities were skipped due to duplicate emails.", "error");
      } else {
        showToast("All communities imported successfully!", "success");
      }
      onHide();
    } catch (error) {
      console.error("Submission error:", error);
      showToast("Server error submitting communities", "error");
    } finally {
      stopLoading();
    }
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      size="lg"
      aria-labelledby="add-community-modal"
      className="add-community-modal"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-uppercase" id="add-community-modal">
          Import Communities
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {rowErrors.length > 0 && (
          <div className="error-summary text-danger mb-3">
            <h5>Validation Errors</h5>
            <ul>
              {rowErrors.map(({ row, errors }) => (
                <li key={row}>
                  Row {row}:{" "}
                  {Object.entries(errors)
                    .map(([field, msg]) => `${field}: ${msg}`)
                    .join(", ")}
                </li>
              ))}
            </ul>
          </div>
        )}
        <FileUpload onDataParsed={handleBulkSubmit} />
      </Modal.Body>
    </Modal>
  );
}

export default ImportCommunityModal;
